import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { FaBullseye, FaChartLine, FaHeart, FaTrophy } from "react-icons/fa";

const steps = [
  {
    title: "Set Your Goals",
    desc: "Define your fitness objectives clearly and get a tailored experience.",
    icon: <FaBullseye className="text-green-400 text-xl mr-2" />,
  },
  {
    title: "Track Your Progress",
    desc: "Log meals, workouts, and daily activities with ease.",
    icon: <FaChartLine className="text-green-400 text-xl mr-2" />,
  },
  {
    title: "Stay Motivated",
    desc: "Receive personalized insights, encouragement, and reminders.",
    icon: <FaHeart className="text-green-400 text-xl mr-2" />,
  },
  {
    title: "Achieve Results",
    desc: "Transform consistently and reach your potential with FitTrack.",
    icon: <FaTrophy className="text-green-400 text-xl mr-2" />,
  },
];

const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.2,
      duration: 0.6,
      ease: "easeOut",
    },
  }),
};

export default function HowItWorksText() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="text-white">
      {/* Heading */}
      {isLoading ? (
        <div className="h-8 w-1/2 bg-gray-700 rounded mb-6 animate-pulse" />
      ) : (
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-6 text-green-400">
          How FitTrack Works
        </h2>
      )}

      {/* Step List */}
      {isLoading ? (
        <ul className="space-y-5">
          {Array(4)
            .fill(0)
            .map((_, index) => (
              <li key={index} className="animate-pulse flex gap-3 items-start">
                <div className="h-6 w-6 bg-gray-600 rounded-full mt-1" />
                <div className="flex-1 space-y-2">
                  <div className="h-4 bg-gray-700 rounded w-1/3" />
                  <div className="h-4 bg-gray-600 rounded w-4/5" />
                </div>
              </li>
            ))}
        </ul>
      ) : (
        <ol className="list-decimal ml-6 space-y-6 text-gray-300">
          {steps.map((step, index) => (
            <motion.li
              key={index}
              custom={index}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.6 }}
              variants={fadeInUp}
              className="flex items-start gap-3"
            >
              {step.icon}
              <div>
                <strong className="text-white">{step.title}:</strong>{" "}
                <span className="text-gray-300">{step.desc}</span>
              </div>
            </motion.li>
          ))}
        </ol>
      )}
    </div>
  );
}
